import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import LineString from '../LineString';
import GeometryFactory from '../GeometryFactory';
import IllegalArgumentException from '../../../../../java/lang/IllegalArgumentException';
import Point from '../Point';
import Polygon from '../Polygon';
import MultiPoint from '../MultiPoint';
import LinearRing from '../LinearRing';
import MultiPolygon from '../MultiPolygon';
import GeometryCollection from '../GeometryCollection';
import ArrayList from '../../../../../java/util/ArrayList';
import MultiLineString from '../MultiLineString';
var GeometryTransformer = /*#__PURE__*/function () {
  function GeometryTransformer() {
    _classCallCheck(this, GeometryTransformer);
    GeometryTransformer.constructor_.apply(this, arguments);
  }
  _createClass(GeometryTransformer, [{
    key: "transformPoint",
    value: function transformPoint(geom, parent) {
      return this._factory.createPoint(this.transformCoordinates(geom.getCoordinateSequence(), geom));
    }
  }, {
    key: "transformPolygon",
    value: function transformPolygon(geom, parent) {
      var isAllValidLinearRings = true;
      var shell = this.transformLinearRing(geom.getExteriorRing(), geom);
      if (shell === null || !(shell instanceof LinearRing) || shell.isEmpty()) isAllValidLinearRings = false;
      var holes = new ArrayList();
      for (var i = 0; i < geom.getNumInteriorRing(); i++) {
        var hole = this.transformLinearRing(geom.getInteriorRingN(i), geom);
        if (hole === null || hole.isEmpty()) continue;
        if (!(hole instanceof LinearRing)) isAllValidLinearRings = false;
        holes.add(hole);
      }
      if (isAllValidLinearRings) {
        return this._factory.createPolygon(shell, holes.toArray([]));
      } else {
        var components = new ArrayList();
        if (shell !== null) components.add(shell);
        components.addAll(holes);
        return this._factory.buildGeometry(components);
      }
    }
  }, {
    key: "createCoordinateSequence",
    value: function createCoordinateSequence(coords) {
      return this._factory.getCoordinateSequenceFactory().create(coords);
    }
  }, {
    key: "getInputGeometry",
    value: function getInputGeometry() {
      return this._inputGeom;
    }
  }, {
    key: "transformMultiLineString",
    value: function transformMultiLineString(geom, parent) {
      var transGeomList = new ArrayList();
      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var transformGeom = this.transformLineString(geom.getGeometryN(i), geom);
        if (transformGeom === null) continue;
        if (transformGeom.isEmpty()) continue;
        transGeomList.add(transformGeom);
      }
      return this._factory.buildGeometry(transGeomList);
    }
  }, {
    key: "transformCoordinates",
    value: function transformCoordinates(coords, parent) {
      return this.copy(coords);
    }
  }, {
    key: "transformLineString",
    value: function transformLineString(geom, parent) {
      return this._factory.createLineString(this.transformCoordinates(geom.getCoordinateSequence(), geom));
    }
  }, {
    key: "transformMultiPoint",
    value: function transformMultiPoint(geom, parent) {
      var transGeomList = new ArrayList();
      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var transformGeom = this.transformPoint(geom.getGeometryN(i), geom);
        if (transformGeom === null) continue;
        if (transformGeom.isEmpty()) continue;
        transGeomList.add(transformGeom);
      }
      return this._factory.buildGeometry(transGeomList);
    }
  }, {
    key: "transformMultiPolygon",
    value: function transformMultiPolygon(geom, parent) {
      var transGeomList = new ArrayList();
      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var transformGeom = this.transformPolygon(geom.getGeometryN(i), geom);
        if (transformGeom === null) continue;
        if (transformGeom.isEmpty()) continue;
        transGeomList.add(transformGeom);
      }
      return this._factory.buildGeometry(transGeomList);
    }
  }, {
    key: "copy",
    value: function copy(seq) {
      return seq.copy();
    }
  }, {
    key: "transformGeometryCollection",
    value: function transformGeometryCollection(geom, parent) {
      var transGeomList = new ArrayList();
      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var transformGeom = this.transform(geom.getGeometryN(i));
        if (transformGeom === null) continue;
        if (this._pruneEmptyGeometry && transformGeom.isEmpty()) continue;
        transGeomList.add(transformGeom);
      }
      if (this._preserveGeometryCollectionType) return this._factory.createGeometryCollection(GeometryFactory.toGeometryArray(transGeomList));
      return this._factory.buildGeometry(transGeomList);
    }
  }, {
    key: "transform",
    value: function transform(inputGeom) {
      this._inputGeom = inputGeom;
      this._factory = inputGeom.getFactory();
      if (inputGeom instanceof Point) return this.transformPoint(inputGeom, null);
      if (inputGeom instanceof MultiPoint) return this.transformMultiPoint(inputGeom, null);
      if (inputGeom instanceof LinearRing) return this.transformLinearRing(inputGeom, null);
      if (inputGeom instanceof LineString) return this.transformLineString(inputGeom, null);
      if (inputGeom instanceof MultiLineString) return this.transformMultiLineString(inputGeom, null);
      if (inputGeom instanceof Polygon) return this.transformPolygon(inputGeom, null);
      if (inputGeom instanceof MultiPolygon) return this.transformMultiPolygon(inputGeom, null);
      if (inputGeom instanceof GeometryCollection) return this.transformGeometryCollection(inputGeom, null);
      throw new IllegalArgumentException('Unknown Geometry subtype: ' + inputGeom.getGeometryType());
    }
  }, {
    key: "transformLinearRing",
    value: function transformLinearRing(geom, parent) {
      var seq = this.transformCoordinates(geom.getCoordinateSequence(), geom);
      if (seq === null) return this._factory.createLinearRing(null);
      var seqSize = seq.size();
      if (seqSize > 0 && seqSize < 4 && !this._preserveType) return this._factory.createLineString(seq);
      return this._factory.createLinearRing(seq);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._inputGeom = null;
      this._factory = null;
      this._pruneEmptyGeometry = true;
      this._preserveGeometryCollectionType = true;
      this._preserveCollections = false;
      this._preserveType = false;
    }
  }]);
  return GeometryTransformer;
}();
export { GeometryTransformer as default };